import { getRequest } from "services/apiService"

const downloadCSV = async (api: string) => {
    const response = await getRequest(api, "text/csv")

    if (!response.ok) {
        throw new Error(`Kunde inte ladda ner CSV. Status: ${response.status}`)
    }

    const contentDisposition = response.headers.get("Content-Disposition") ?? ""
    let filename = "export.csv"

    // Stöd för både filename="x.csv" och filename*=UTF-8''x.csv
    const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
    const plainMatch = contentDisposition.match(/filename\s*=\s*"?(.*?)"?($|;)/i)

    if (utf8Match) {
        const [, encodedFilename] = utf8Match
        filename = decodeURIComponent(encodedFilename)
    } else if (plainMatch) {
        const [, extractedFilename] = plainMatch
        filename = extractedFilename
    }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.URL.revokeObjectURL(url)
}

export default downloadCSV